/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_Custom_Buy_ButtonInputs */

const es_components_buy_messages_modal_custom_buy_button = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_Buy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar`)
};

const en_components_buy_messages_modal_custom_buy_button = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_Buy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy`)
};

/**
* | output |
* | --- |
* | "Buy" |
*
* @param {Components_Buy_Messages_Modal_Custom_Buy_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_custom_buy_button = /** @type {((inputs?: Components_Buy_Messages_Modal_Custom_Buy_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_Custom_Buy_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_custom_buy_button(inputs)
	return en_components_buy_messages_modal_custom_buy_button(inputs)
});
export { components_buy_messages_modal_custom_buy_button as "components.buy_messages_modal.custom.buy_button" }